import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PokerHandFormatter from './components/PokerHandFormatter';
import { AppProvider, useAppContext } from './contexts/AppContext';
import DevTools from './components/DevTools';
import { initGA, trackPageView } from './services/analytics';

function AppContent() {
  const { appName } = useAppContext();
  
  useEffect(() => {
    // 初始化 GA4 并跟踪页面访问
    initGA();
    trackPageView();
  }, []);

  return (
    <>
      <Helmet>
        <title>{appName}</title>
      </Helmet>
      <div className="App">
        <PokerHandFormatter />
        <DevTools />
      </div>
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;